import { AdminSpecialCalculationCostListTemplate } from '@/components/templates';
import { useSpecialCalculationCostCsv, useSpecialCalculationCostList } from '@/hooks/admin';
import {
  SpecialCalculationCost,
  SpecialCalculationCostFilterParams,
} from '@/types/special-calculation-cost';
import { japaneseDateToISO } from '@/utils/dateConverter';
import { SorterResult } from 'antd/es/table/interface';
import { useSearchParams } from 'react-router-dom';

const SiteAdminSpecialCalculationCostListPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const page = searchParams.get('page') || '1';
  const sortBy = searchParams.get('sort_by') || undefined;
  const order = searchParams.get('order') as 'ascend' | 'descend' | null;
  const searchInsurerNumber = searchParams.get('search_insurer_number') || undefined;
  const searchInsurerName = searchParams.get('search_insurer_name') || undefined;
  const availableDate = searchParams.get('available_date') || undefined;

  const csvQuery = {
    sort_by: sortBy,
    order: order || undefined,
    search_insurer_number: searchInsurerNumber,
    search_insurer_name: searchInsurerName,
    available_date: japaneseDateToISO(availableDate ?? '') || undefined,
  };

  const { data, isLoading } = useSpecialCalculationCostList({
    page,
    sort_by: sortBy,
    order: order || undefined,
    search_insurer_number: searchInsurerNumber,
    search_insurer_name: searchInsurerName,
    available_date: japaneseDateToISO(availableDate ?? '') || undefined,
  });

  const { mutate: downloadCsv, isPending: isCsvLoading } = useSpecialCalculationCostCsv();

  const handleCsvDownload = (_filters?: SpecialCalculationCostFilterParams) => {
    downloadCsv(csvQuery);
  };

  const breadcrumbItems = [{ title: '特殊医療助成金' }];

  const handlePageChange = (page: number) => {
    const params = new URLSearchParams(searchParams);
    params.set('page', page.toString());
    setSearchParams(params);
  };

  const handleSearch = (filters: SpecialCalculationCostFilterParams) => {
    const params = new URLSearchParams(searchParams);
    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        params.set(key, value);
      } else {
        params.delete(key);
      }
    });
    params.set('page', '1');
    setSearchParams(params);
  };

  const handleTableChange = (
    sorter: SorterResult<SpecialCalculationCost> | SorterResult<SpecialCalculationCost>[]
  ) => {
    const params = new URLSearchParams(searchParams);
    const single = Array.isArray(sorter) ? sorter[0] : sorter;
    if (single.order) {
      params.set('sort_by', (single.field || single.columnKey) as string);
      params.set('order', single.order);
    } else {
      params.delete('sort_by');
      params.delete('order');
    }
    params.set('page', '1');
    setSearchParams(params);
  };

  return (
    <AdminSpecialCalculationCostListTemplate
      data={data?.data || []}
      total={data?.meta.total || 0}
      current={data?.meta.current_page || 1}
      pageSize={data?.meta.per_page || 20}
      sortInfo={{ columnKey: sortBy, order: order || undefined }}
      onChange={handlePageChange}
      onTableChange={handleTableChange}
      onSearch={handleSearch}
      onCsvDownload={handleCsvDownload}
      isCsvLoading={isCsvLoading}
      breadcrumbItems={breadcrumbItems}
      isLoading={isLoading}
    />
  );
};

export default SiteAdminSpecialCalculationCostListPage;
